module.exports = ".title {\n  width: 100%; }\n\n.mat-form-field {\n  width: 30%; }\n\n.example-full-width {\n  width: 100%; }\n\n.btn-container {\n  margin-top: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fiscalia/component/report-errors/report-errors.component.scss
// module id = ./src/app/fiscalia/component/report-errors/report-errors.component.scss
// module chunks = main